import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-accent/5"></div>
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1552930294-6b595f4c2974?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay"></div>
      
      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-heading font-bold mb-6">Ready for a Transformation?</h2>
          <p className="text-xl text-textMuted mb-10 max-w-2xl mx-auto">
            Book your appointment today and experience the pinnacle of automotive care in Montreal. Spots fill up quickly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/booking" className="btn-primary text-lg px-10 py-4">
              Reserve Your Spot
            </Link>
            <Link to="/packages" className="btn-outline text-lg px-10 py-4 bg-primary border-white/10">
              View Packages
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;